// Polish dictionary
// Terminology: "encryption key" -> "klucz szyfrujący", "passphrase" -> "fraza zabezpieczająca",
// "seed phrase" -> "fraza seed". Product names SecurePaper and QR stay untranslated.
const pl = {
  common: {
    backToHome: 'Wróć na stronę główną',
  },
  nav: {
    website: 'O nas',
    createSecurePaper: 'Utwórz SecurePaper',
    decryptSecurePaper: 'Odszyfruj SecurePaper',
    history: 'Historia',
    keys: 'Klucze',
    logout: 'Wyloguj się',
    login: 'Zaloguj się',
    signup: 'Zarejestruj się',
    toggleMenu: 'Przełącz menu',
    userMenu: 'Menu użytkownika',
    user: 'Użytkownik',
    language: 'Język',
  },
  legal: {
    canonicalNote: 'Kanoniczna, zawsze aktualna wersja tego dokumentu jest opublikowana na naszej stronie.',
    openFull: 'Przeczytaj pełny dokument',
    privacyTitle: 'Polityka prywatności',
    termsTitle: 'Regulamin',
    securityTitle: 'Model bezpieczeństwa',
    securityNote: 'To, jak dokładnie SecurePaper chroni Twoje dane - szyfrowanie AES-256-GCM po stronie przeglądarki, co i gdzie jest przechowywane, pełny format danych oraz deszyfrator offline - jest udokumentowane na naszej stronie.',
  },
  footer: {
    tagline: 'Zabezpiecz swoje poufne informacje dzięki szyfrowaniu przyjaznemu dla papieru',
    quickLinks: 'Na skróty',
    home: 'Strona główna',
    createPaper: 'Utwórz dokument',
    myPapers: 'Moje dokumenty',
    myKeys: 'Moje klucze',
    information: 'Informacje',
    securityModel: 'Model bezpieczeństwa',
    privacyPolicy: 'Polityka prywatności',
    terms: 'Regulamin',
    contact: 'Kontakt',
    howItWorks: 'Jak to działa i FAQ',
    offlineDecryptor: 'Deszyfrator offline',
    website: 'O SecurePaper',
    copyright: '© {year} SecurePaper. Wszelkie prawa zastrzeżone.',
    disclaimer: 'Twoje dane są szyfrowane algorytmem AES-256 w Twojej przeglądarce –',
    seeHow: 'zobacz jak',
  },
  dashboard: {
    title: 'Twój panel SecurePaper',
    welcomeBack: 'Witaj ponownie, {email}!',
    subtitle: 'Twórz zaszyfrowane dokumenty papierowe i bezpiecznie nimi zarządzaj',
    createNew: 'Utwórz nowy SecurePaper',
    createNewDesc: 'Zaszyfruj nowe poufne informacje',
    scan: 'Zeskanuj SecurePaper',
    scanDesc: 'Odszyfruj istniejące dokumenty',
    popular: 'Popularne:',
    noAccountStrong: 'Korzystasz z SecurePaper bez konta.',
    noAccountInfo: 'Twoje klucze są zapisane lokalnie w tej przeglądarce.',
  },
  templates: {
    'seed-phrase': {
      name: 'Fraza seed portfela',
      subject: 'Fraza seed portfela kryptowalut',
      content: 'Nazwa portfela: \nTyp portfela (sprzętowy/programowy): \n\nFraza seed (słowa w kolejności):\n1. \n2. \n3. \n4. \n5. \n6. \n7. \n8. \n9. \n10. \n11. \n12. \n\nFraza zabezpieczająca (25. słowo), jeśli jest: ',
    },
    '2fa-codes': {
      name: 'Kody zapasowe 2FA',
      subject: 'Kody zapasowe 2FA',
      content: 'Usługa: \nKonto / e-mail: \n\nKody zapasowe:\n- \n- \n- \n- \n- \n',
    },
    'emergency-access': {
      name: 'Dostęp awaryjny',
      subject: 'Dostęp awaryjny dla mojej rodziny',
      content: 'Jeśli coś mi się stanie, ten dokument daje Wam dostęp do najważniejszych rzeczy.\n\nMenedżer haseł: \nHasło główne: \nPIN do telefonu: \nKonto e-mail + hasło: \nDostęp do banku: \n\nOsoby do kontaktu:\n- \n\nNotatki: ',
    },
    'bank-details': {
      name: 'Dane bankowe',
      subject: 'Dane bankowe',
      content: 'Bank: \nLogin: \nHasło: \nPIN do karty: \nNumer konta: \n\nNotatki: ',
    },
    wifi: {
      name: 'Wi-Fi i kody domowe',
      subject: 'Sieć domowa i kody',
      content: 'Sieć Wi-Fi: \nHasło Wi-Fi: \nHasło administratora routera: \nKod alarmu: \nKombinacja sejfu: \n\nNotatki: ',
    },
  },
  newTextbox: {
    title: 'Utwórz SecurePaper',
    subtitle: 'Zamień poufne informacje w zaszyfrowane kody SecurePaper i bezpiecznie przechowuj je na papierze',
    step1: 'Wprowadź informacje',
    step2: 'Wygenerowany SecurePaper',
    startFromTemplate: 'Zacznij od szablonu',
    optional: '(opcjonalnie)',
    paperName: 'Nazwa dokumentu',
    paperNamePlaceholder: 'np. Kombinacja sejfu domowego albo Dane bankowe (opcjonalnie)',
    protectionMethod: 'Metoda ochrony',
    encryptionKeyOption: 'Klucz szyfrujący',
    encryptionKeyOptionDesc: 'Losowy klucz jest generowany i zapisywany {location}. Najsilniejsza opcja — nie musisz niczego pamiętać.',
    savedToAccount: 'na Twoim koncie',
    savedInBrowser: 'w tej przeglądarce',
    passphraseOption: 'Fraza zabezpieczająca',
    passphraseOptionDesc: 'Wybierasz frazę zabezpieczającą i ją zapamiętujesz. Nic nie jest nigdzie zapisywane — papier plus Twoja pamięć to pełna kopia zapasowa.',
    passphraseLabel: 'Fraza zabezpieczająca',
    passphrasePlaceholder: 'Co najmniej 8 znaków — im dłuższa, tym silniejsza',
    repeatPassphrase: 'Powtórz frazę zabezpieczającą',
    repeatPassphrasePlaceholder: 'Wpisz ponownie tę samą frazę',
    passphraseTooShort: 'Fraza zabezpieczająca musi mieć co najmniej 8 znaków',
    passphraseMismatch: 'Frazy zabezpieczające nie są identyczne',
    passphraseWarning: 'Zapomnianej frazy zabezpieczającej nie da się odzyskać — bez niej dokument stanie się nieczytelny.',
    encryptionKeyLabel: 'Klucz szyfrujący',
    createNewKey: 'Utwórz nowy klucz',
    createNewKeyDesc: 'Wygeneruj nowy bezpieczny klucz szyfrujący',
    useExistingKey: 'Użyj istniejącego klucza',
    chooseFromKeys: 'Wybierz jeden z zapisanych kluczy ({count})',
    localSuffix: '({count} lokalnie)',
    accountLocalSuffix: '({account} na koncie, {local} lokalnie)',
    selectKey: '-- Wybierz klucz --',
    accountKeys: 'Klucze konta',
    localKeys: 'Klucze lokalne',
    keyCreatedOn: 'Klucz utworzony {date}',
    localKeyCreatedOn: 'Klucz lokalny utworzony {date}',
    localTag: '(lokalny)',
    loadingKeys: 'Wczytywanie kluczy...',
    contentToSecure: 'Treść do zabezpieczenia',
    contentPlaceholder: 'Wpisz poufne informacje, które normalnie zapisujesz na papierze...',
    contentHint: 'Ta treść zostanie zaszyfrowana i zamieniona w kod SecurePaper',
    charCount: '{count} zn.',
    qrCodesOne: '≈ 1 kod QR',
    qrCodesFew: '≈ {count} kody QR',
    qrCodesMany: '≈ {count} kodów QR',
    longContentWarning: 'Długa treść oznacza wiele kodów QR do wydrukowania i ponownego zeskanowania ({count}). Rozważ podzielenie jej na kilka krótszych dokumentów.',
    generating: 'Generowanie...',
    generate: 'Wygeneruj SecurePaper',
    info1Title: 'Lepsze niż odręczne notatki',
    info1Desc: 'Twoje dane są szyfrowane algorytmem AES-256 w przeglądarce — w przeciwieństwie do łatwych do podejrzenia odręcznych notatek',
    info2Title: 'Drukuj i przechowuj bezpiecznie',
    info2Desc: 'Generuj kody SecurePaper, które możesz wydrukować i przechowywać fizycznie — znacznie bezpieczniej niż zwykły tekst',
  },
  result: {
    ready: 'Twój SecurePaper jest gotowy',
    readySubtitle: 'Twoje informacje zostały zaszyfrowane i zamienione w kod SecurePaper',
    stepInfoEntered: 'Informacje wprowadzone',
    stepGenerated: 'Wygenerowany SecurePaper',
    yourSecurePaper: 'Twój SecurePaper',
    download: 'Pobierz kod SecurePaper',
    print: 'Wydrukuj dokument',
    howToAccess: 'Aby uzyskać dostęp do informacji:',
    goDecrypt: 'Przejdź do strony odszyfrowywania SecurePaper',
    scanPrinted: 'Zeskanuj wydrukowany kod SecurePaper',
    passphraseStep: 'Wpisz wybraną przez siebie frazę zabezpieczającą — nic więcej nie jest potrzebne',
    loggedInKeysStep: 'Użyj zapisanych kluczy szyfrujących albo zeskanuj/wgraj klucz',
    localKeysStep: 'Użyj kluczy szyfrujących zapisanych lokalnie albo zeskanuj/wgraj klucz',
    emergencyBackup: 'Kopia awaryjna:',
    downloadOfflineDecryptor: 'pobierz deszyfrator offline',
    offlineDecryptorDesc: '— pojedynczy plik, który odszyfruje Twoje dokumenty nawet bez naszych serwerów',
    printingGuideLink: 'Poradnik drukowania i przechowywania — jak zadbać o dokumenty i klucze na lata',
    passphraseAlert1: 'Ten dokument jest chroniony Twoją frazą zabezpieczającą.',
    passphraseAlertStrong: 'Nic nie zostało nigdzie zapisane',
    passphraseAlert2: '— wydrukowany dokument plus Twoja fraza zabezpieczająca to pełna kopia zapasowa. Jeśli zapomnisz frazy, dokumentu nie da się odszyfrować.',
    notLoggedInWarning: 'Korzystasz bez logowania, więc Twój klucz szyfrujący jest zapisany lokalnie w tej przeglądarce.',
    notLoggedInWarningStrong: 'Załóż konto, aby zsynchronizować klucze z chmurą i mieć do nich dostęp z każdego urządzenia.',
    usingExistingAccount: 'Używany jest Twój istniejący klucz szyfrujący z konta.',
    keySavedAccount: 'Twój klucz szyfrujący został zapisany na koncie. Masz do niego dostęp w każdej chwili z poziomu panelu.',
    usingExistingLocal: 'Używany jest Twój istniejący klucz szyfrujący zapisany lokalnie.',
    keySavedLocal: 'Twój klucz szyfrujący został zapisany lokalnie.',
    signupLink: 'Zarejestruj się',
    signupToSync: 'i zsynchronizuj go ze swoim kontem.',
    encryptionKeySection: 'Klucz szyfrujący',
    hide: 'Ukryj',
    show: 'Pokaż',
    saving: 'Zapisywanie...',
    saveToAccount: 'Zapisz na koncie',
    saveLocally: 'Zapisz lokalnie',
    copyKey: 'Kopiuj klucz',
    copiedKey: 'Skopiowano!',
    copyKeyTitle: 'Skopiuj klucz szyfrujący do schowka',
    statusUsingExistingAccount: 'Używasz istniejącego klucza szyfrującego z konta',
    statusUsingExistingLocal: 'Używasz istniejącego klucza szyfrującego zapisanego lokalnie',
    statusSavedAccount: 'Klucz szyfrujący zapisany na Twoim koncie',
    statusSavedLocal: 'Klucz szyfrujący zapisany lokalnie',
    createAnother: 'Utwórz kolejny dokument',
    goToDashboard: 'Przejdź do panelu',
    notifSavedAccount: 'Wiadomość i klucz zapisane na Twoim koncie!',
    notifKeySavedLocally: 'Klucz szyfrujący zapisany lokalnie!',
    notifMessageSaved: 'Wiadomość została zapisana!',
    notifDownloaded: 'Kod SecurePaper został pobrany!',
    notifPdfCreated: 'Dokument PDF został utworzony!',
    keyForName: 'Klucz do: {subject}',
    untitledMessage: 'Wiadomość bez nazwy',
  },
  scan: {
    title: 'Zeskanuj SecurePaper',
    subtitle: 'Odszyfruj swoje dane z kodów SecurePaper',
    step1: 'Zeskanuj kod SecurePaper',
    step2: 'Odszyfruj treść',
    scanYour: 'Zeskanuj swój SecurePaper',
    scanInstructions: 'Zeskanuj kod SecurePaper ze swojego dokumentu SecurePaper:',
    multiPartTitle: 'Skanowanie kodu wieloczęściowego',
    multiPartInstr: 'Zeskanuj wszystkie części ({total}), aby odszyfrować',
    partsScanned: 'Zeskanowano {scanned} z {total} części',
    part: 'Część {num}',
    initCamera: 'Uruchamianie kamery...',
    scanningAuto: 'Skanowanie automatyczne...',
    switchCamera: 'Przełącz kamerę',
    cancel: 'Anuluj',
    useCamera: 'Użyj kamery',
    useCameraDesc: 'Zeskanuj kod SecurePaper kamerą swojego urządzenia',
    startCamera: 'Uruchom kamerę',
    uploadImage: 'Wgraj obraz',
    uploadImageDesc: 'Wgraj obraz zawierający kod SecurePaper',
    processing: 'Przetwarzanie obrazu...',
    orPasteCode: '— albo wklej kod jako tekst —',
    pasteCodePlaceholder: 'Wklej tutaj tekst kodu SecurePaper (w przypadku kodów wieloczęściowych wklej wszystkie części — każda zaczyna się od „SP:”)',
    continuePasted: 'Kontynuuj z wklejonym kodem',
    decryptYourContent: 'Odszyfruj swoją treść',
    scanningForKey: 'Skanowanie klucza szyfrującego',
    scanningForKeyAuto: 'Automatyczne skanowanie klucza...',
    tryingSavedKeys: 'Próba odszyfrowania zapisanymi kluczami...',
    passphraseProtected: 'Dokument chroniony frazą zabezpieczającą',
    passphraseProtectedDesc: 'Ten SecurePaper został zabezpieczony frazą. Wpisz ją, aby odsłonić treść — plik klucza nie jest potrzebny.',
    enterPassphrasePlaceholder: 'Wpisz frazę zabezpieczającą',
    decryptContent: 'Odszyfruj treść',
    enterKey: 'Podaj klucz szyfrujący',
    enterKeyDesc: 'Podaj klucz szyfrujący, aby odsłonić treść',
    scanKey: 'Zeskanuj klucz SecurePaper',
    scanKeyDesc: 'Zeskanuj kod klucza SecurePaper kamerą',
    uploadKeyFile: 'Wgraj plik klucza',
    uploadKeyFileDesc: 'Wgraj plik zawierający Twój klucz szyfrujący',
    keyLoaded: 'Klucz wczytany',
    orPasteKey: '— albo wklej klucz jako tekst —',
    pasteKeyPlaceholder: 'Wklej tutaj swój klucz szyfrujący (64 znaki szesnastkowe albo starszy format 3f8a...iv...9c2e)',
    keyLoadedPrefix: 'Wczytany klucz: ',
    decryptionSuccessful: 'Odszyfrowanie powiodło się',
    decryptedContent: 'Odszyfrowana treść',
    copied: 'Skopiowano!',
    copy: 'Kopiuj',
    decryptNewCode: 'Odszyfruj nowy kod',
    backToDashboard: 'Wróć do panelu',
    scannedKeyName: 'Zeskanowany klucz - {date}',
    errNoQrDetected: 'Nie wykryto kodu SecurePaper na obrazie.',
    errKeySplit: 'Kluczy szyfrujących nie można dzielić na wiele kodów. Wgraj pojedynczy kod klucza.',
    errPartsMissing: 'Znaleziono {found} z {total} części na obrazie. Liczba brakujących części: {missing}.',
    errProcessImage: 'Nie udało się przetworzyć obrazu: {message}',
    errUnknown: 'Nieznany błąd',
    errProvideContentFirst: 'Najpierw podaj treść kodu SecurePaper',
    errEnterPassphrase: 'Wpisz frazę zabezpieczającą dla tego dokumentu',
    errProvideBoth: 'Podaj zarówno treść SecurePaper, jak i klucz szyfrujący',
    errInvalidKeyFormat: 'Nieprawidłowy format klucza szyfrującego. Oczekiwano 64 znaków szesnastkowych albo starszego formatu <klucz>iv<iv>',
    errPastedPartsMissing: 'Ten kod ma {total} części, a wklejono tylko {pasted}. Wklej wszystkie części (każda zaczyna się od „SP:”).',
    errCameraNotReady: 'Kamera nie jest gotowa. Poczekaj, aż się uruchomi.',
    errVideoNotReady: 'Obraz z kamery nie jest gotowy. Odczekaj chwilę i spróbuj ponownie.',
    errCaptureFailed: 'Nie udało się przechwycić obrazu z kamery.',
    errCaptureFailedWith: 'Nie udało się przechwycić obrazu: {message}',
    errInitCameraFailed: 'Nie udało się uruchomić kamery. Spróbuj ponownie.',
    errPlaybackFailed: 'Nie udało się uruchomić podglądu z kamery: {message}',
    errCameraAccess: 'Nie udało się uzyskać dostępu do kamery. ',
    errAllowPermissions: 'Zezwól na dostęp do kamery i spróbuj ponownie.',
    errNoCamera: 'Nie znaleziono kamery w tym urządzeniu.',
    errCameraInUse: 'Kamera jest już używana przez inną aplikację.',
    errUnknownOccurred: 'Wystąpił nieznany błąd.',
  },
  login: {
    title: 'Zaloguj się do SecurePaper',
    email: 'Adres e-mail',
    emailRequired: 'Adres e-mail jest wymagany',
    emailInvalid: 'Adres e-mail jest nieprawidłowy',
    password: 'Hasło',
    passwordRequired: 'Hasło jest wymagane',
    forgotPassword: 'Nie pamiętasz hasła?',
    signIn: 'Zaloguj się',
    or: 'lub',
    continueWithGoogle: 'Kontynuuj przez Google',
    createAccountLink: 'Załóż konto.',
    unexpectedError: 'Nieoczekiwany błąd',
    emailNotVerified1: 'Twój adres e-mail nie został zweryfikowany. Kliknij link w e-mailu powitalnym albo kliknij',
    emailNotVerifiedHere: 'tutaj',
    emailNotVerified2: ', aby wysłać go ponownie.',
  },
  signup: {
    title: 'Załóż konto',
    checkEmail: 'Sprawdź swoją skrzynkę',
    sentConfirmationBefore: 'Wysłaliśmy link potwierdzający na adres',
    activateInfo: 'Kliknij link w tej wiadomości, aby aktywować konto. Jeśli jej nie widzisz, sprawdź folder ze spamem.',
    goToLogin: 'Przejdź do logowania',
    emailNote: 'Od czasu do czasu otrzymasz e-maile związane z kontem. Obiecujemy nie udostępniać nikomu Twojego adresu.',
    passwordHint: 'Użyj co najmniej jednej małej litery, jednej cyfry i siedmiu znaków.',
    passwordMin: 'Hasło musi mieć co najmniej 7 znaków',
    passwordLower: 'Hasło musi zawierać co najmniej jedną małą literę',
    passwordNum: 'Hasło musi zawierać co najmniej jedną cyfrę',
    emailExists: 'Konto z tym adresem e-mail już istnieje. Spróbuj się zalogować.',
    agreePrefix: 'Klikając „Załóż konto” poniżej, akceptujesz',
    termsLink: 'Regulamin',
    privacyLink: 'Politykę prywatności',
    createAccount: 'Załóż konto',
    signUpWithGoogle: 'Zarejestruj się przez Google',
  },
  listCodes: {
    loading: 'Wczytywanie kluczy szyfrujących...',
    errorLoading: 'Błąd wczytywania kluczy: {error}',
    noKeysFound: 'Nie znaleziono kluczy szyfrujących',
    noKeysMessage: 'Utwórz nową zaszyfrowaną wiadomość, aby wygenerować klucze.',
    createNewMessage: 'Utwórz nową wiadomość',
    importFromBackup: 'Importuj klucze z pliku kopii zapasowej',
    yourSavedKeys: 'Twoje zapisane klucze',
    syncing: 'Synchronizowanie...',
    syncAllLocal: 'Zsynchronizuj wszystkie klucze lokalne',
    exportTitle: 'Pobierz wszystkie klucze jako plik kopii zapasowej JSON',
    export: 'Eksportuj',
    importTitle: 'Przywróć klucze z pliku kopii zapasowej',
    import: 'Importuj',
    createNewKey: 'Utwórz nowy klucz',
    backupHint1: 'Zrób kopię zapasową:',
    backupHintLink: 'wyeksportuj swoje klucze',
    backupHint2: 'do pliku i przechowaj go w bezpiecznym miejscu (pendrive, menedżer haseł). Utrata kluczy sprawi, że wydrukowane dokumenty staną się nieczytelne.',
    localKeysSection: 'Klucze lokalne ({count})',
    localKeysDesc: 'Te klucze są przechowywane w Twojej przeglądarce',
    cloudKeysSection: 'Klucze w chmurze ({count})',
    cloudKeysDesc: 'Te klucze są zapisane na Twoim koncie',
    untitledKey: 'Klucz bez nazwy',
    localBadge: 'Lokalny',
    cloudBadge: 'Chmura',
    showKey: 'Pokaż klucz',
    hideKey: 'Ukryj klucz',
    saveToCloud: 'Zapisz w chmurze',
    deleting: 'Usuwanie...',
    delete: 'Usuń',
    created: 'Utworzony: {date}',
    storedLocally: 'Przechowywany lokalnie w tej przeglądarce',
    storedInAccount: 'Przechowywany na Twoim koncie',
    notBackupFile: 'Ten plik nie jest kopią zapasową kluczy SecurePaper',
    importedKeyName: 'Zaimportowany klucz {date}',
    importedResult: 'Zaimportowano klucze: {count}',
    importedNone: 'Nie zaimportowano żadnych kluczy (wszystkie klucze z pliku już istnieją)',
    readBackupFailed: 'Nie udało się odczytać pliku kopii zapasowej',
  },
  cookie: {
    title: 'Twoje ustawienia prywatności',
    text: 'Używamy plików cookie i podobnych technologii, aby ulepszać działanie serwisu, analizować ruch i rozumieć sposób korzystania z niego. W każdej chwili możesz zaakceptować wszystkie, odrzucić opcjonalne pliki cookie albo dostosować swoje preferencje.',
    privacyPolicy: 'Polityka prywatności',
    cookieSettings: 'Ustawienia plików cookie',
    doNotShare: 'Nie udostępniaj moich danych osobowych',
    rejectAll: 'Odrzuć wszystkie',
    acceptAll: 'Zaakceptuj wszystkie',
    preferencesTitle: 'Preferencje plików cookie',
    close: 'Zamknij',
    preferencesText: 'Zarządzaj tym, jak SecurePaper używa plików cookie i podobnych technologii. Możesz zmienić swoje wybory w dowolnym momencie. Niezbędne pliki cookie są zawsze włączone, ponieważ są wymagane do działania serwisu.',
    essential: 'Niezbędne pliki cookie',
    essentialDesc: 'Wymagane do podstawowego działania i bezpieczeństwa serwisu. Nie można ich wyłączyć.',
    alwaysActive: 'Zawsze aktywne',
    analytics: 'Analityczne pliki cookie',
    analyticsDesc: 'Pomagają nam zrozumieć, jak odwiedzający korzystają z serwisu, dzięki czemu możemy poprawiać wydajność i wygodę użytkowania.',
    functional: 'Funkcjonalne pliki cookie',
    functionalDesc: 'Umożliwiają dodatkowe funkcje i personalizację, np. zapamiętywanie Twoich preferencji.',
    rejectNonEssential: 'Odrzuć opcjonalne',
    savePreferences: 'Zapisz preferencje',
  },
};

export default pl;
